import { BlocksIconNotifications } from 'blocks-nextjs/blocks-web-components/components/icon/icons/notifications';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconNotifications = createComponent({ react: React, tagName: 'cat-icon-notifications', elementClass: BlocksIconNotifications });
